'use client';

import React from 'react';
import { Field, useField } from 'react-final-form';
import { FieldValidator } from 'final-form';
import { MoTextInput, MoTextInputProps } from '../MoTextInput';
import { useMoFormContext } from '../MoFormContext/MoFormContext';

export interface MoTextFieldInputProps extends MoTextInputProps {
  name: string;
  validate?: FieldValidator<string | number>;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
}

export function MoTextInputField({
  name,
  type,
  helperText,
  validate,
  onChange = () => {},
  ...rest
}: MoTextFieldInputProps) {
  let helperTextLines: string[] = [];
  if (helperText) {
    helperTextLines = Array.isArray(helperText) ? helperText : [helperText];
  }
  const { meta } = useField(name);

  const { validateOnMount } = useMoFormContext();

  if ((meta.submitFailed || validateOnMount) && meta.error) {
    helperTextLines.push(...[meta.error].flat());
  }
  return (
    <Field<string | number, HTMLElement, string>
      name={name}
      validate={validate}
      subscription={{
        error: true,
        value: true,
        submitFailed: true,
        valid: true,
      }}
      format={(value) => {
        if (type === 'number') {
          if (value === 0) {
            return '0';
          }
          return value ? Number(value).toString() : '';
        }
        return value != null ? String(value) : '';
      }}
      parse={(value) => {
        if (type === 'number') {
          return value ? Number(value) : value;
        }
        return value;
      }}
      render={({ input, meta }) => {
        const props = {
          ...input,
          type,
          error: (meta.submitFailed || validateOnMount) && !meta.valid,
          helperText: helperTextLines.join('\n'),
          onChange: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
            input.onChange(e);
            onChange(e);
          },
          ...rest,
        };

        return <MoTextInput {...props} />;
      }}
    />
  );
}
